var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import AreaRow from '@/components/area-row/AreaRow';
import SelectFilter from '@/components/select-filter/SelectFilter';
import DataTable from '@/components/data-table/DataTable';
import { colorHtml } from '@/support/String';
import { Teacher } from '@/models/Teacher';
import { UserSubject } from '@/models/UserSubject';
import { Level } from '@/models/Level';
import ErrorHandler from '@/support/ErrorHandler';
let CreateAreaDialog = class CreateAreaDialog extends Vue {
    constructor() {
        super(...arguments);
        this.currentStep = 1;
        this.areas = [];
        this.isLoading = true;
        this.selectedSubjects = [];
        this.curriculum = new CurriculumModel();
        this.levels = [];
    }
    mounted() {
        this.selectedSubjects = [];
        this.initialize();
    }
    initialize() {
        // of ze staan in mn filter of ik moet ze ophale
        if (this.$store.state.filter && this.$store.state.filter.Level) {
            this.levels = this.$store.state.filter.Level;
        }
        else {
            this.fetchLevels();
        }
    }
    fetchLevels() {
        new Level()
            .limit(100)
            .all()
            .then((levels) => {
            this.levels = levels;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('subject.area.title', 1),
                plural: this.$tc('subject.area.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'color',
                    transform: colorHtml,
                },
                {
                    text: 'Name',
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Subject().filter('depth', 0),
        };
    }
    close() {
        this.$emit('input', false);
        this.currentStep = 1;
        this.selectedSubjects = [];
    }
    deleteSelectedSubject(index) {
        this.selectedSubjects.splice(index, 1);
    }
    create() {
        if (!this.selectedSubjects || !this.teacher) {
            return;
        }
        const payload = [];
        this.selectedSubjects.forEach((selectedSubject) => {
            const userSubject = {
                subject: selectedSubject.id,
                levels: [],
            };
            payload.push(userSubject);
        });
        this.userSubjects.forEach((userSubject) => {
            const levels = [];
            if (userSubject.levels) {
                userSubject.levels.forEach((level) => {
                    if (level.id) {
                        levels.push(level.id);
                    }
                });
            }
            const userSubjectItem = {
                subject: userSubject.subject,
                levels,
            };
            payload.push(userSubjectItem);
        });
        new UserSubject()
            .user(this.teacher)
            .put(payload)
            .then((subjects) => {
            this.$emit('subjectsAdded');
            this.clear();
        });
    }
    clear() {
        this.selectedSubjects = [];
    }
    currentStepChanged() {
        if (this.currentStep === 2) {
            //
        }
        if (this.currentStep === 3) {
            this.create();
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Teacher !== "undefined" && Teacher) === "function" ? _a : Object)
], CreateAreaDialog.prototype, "teacher", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], CreateAreaDialog.prototype, "userSubjects", void 0);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateAreaDialog.prototype, "currentStepChanged", null);
CreateAreaDialog = __decorate([
    Component({
        components: {
            AreaRow,
            SelectFilter,
            DataTable,
        },
    })
], CreateAreaDialog);
export default CreateAreaDialog;
